import React from "react";

// Portado de chartTrayectoria() del prototipo (línea 666) — mismas
// coordenadas, mismos colores, mismo SVG a mano (sin librería: es un
// gráfico chico y autocontenido, no justifica traer recharts para esto).
export function TrajectoryChart({ baseYear, targetYear, baseEmissions, targetEmissions, series }) {
  if (!(baseYear && targetYear && baseEmissions > 0)) {
    return <div className="sbti-hint">Completá año base, año objetivo y emisiones para ver la trayectoria.</div>;
  }

  const W = 560, H = 210, mx = 46, my = 18;
  const years = targetYear - baseYear;
  const maxY = Math.max(baseEmissions, ...series.map((r) => r.value || 0)) * 1.08;
  const X = (y) => mx + ((y - baseYear) / (years || 1)) * (W - mx - 14);
  const Y = (v) => H - my - (v / maxY) * (H - my * 2);

  const gridLines = [];
  for (let g = 0; g <= 4; g++) {
    const v = (maxY * g) / 4;
    gridLines.push(
      <React.Fragment key={g}>
        <line x1={mx} y1={Y(v)} x2={W - 14} y2={Y(v)} stroke="#E3E7EE" />
        <text x={mx - 6} y={Y(v) + 4} textAnchor="end" fontSize="9.5" fill="#5A5E78">
          {Math.round(v).toLocaleString("es-AR")}
        </text>
      </React.Fragment>
    );
  }

  const xTicks = [];
  const step = Math.max(1, Math.round(years / 8));
  for (let y = baseYear; y <= targetYear; y += step) {
    xTicks.push(
      <text key={y} x={X(y)} y={H - 2} textAnchor="middle" fontSize="9.5" fill="#5A5E78">{y}</text>
    );
  }

  const realPoints = series.filter((r) => r.value > 0 && r.year >= baseYear && r.year <= targetYear);
  const linePath = series
    .filter((r) => r.value > 0)
    .sort((a, b) => a.year - b.year)
    .map((r, i) => `${i ? "L" : "M"}${X(r.year)} ${Y(r.value)}`)
    .join(" ");

  return (
    <>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: "100%", height: "auto" }} role="img" aria-label="Trayectoria de reducción">
        {gridLines}
        {xTicks}
        <line x1={X(baseYear)} y1={Y(baseEmissions)} x2={X(targetYear)} y2={Y(targetEmissions)} stroke="#003872" strokeWidth="3" strokeLinecap="round" />
        <circle cx={X(baseYear)} cy={Y(baseEmissions)} r="5" fill="#003872" />
        <circle cx={X(targetYear)} cy={Y(targetEmissions)} r="5" fill="#578EBF" />
        {linePath && <path d={linePath} fill="none" stroke="#1A1C42" strokeWidth="2" strokeDasharray="4 4" />}
        {realPoints.map((r) => (
          <circle key={r.year} cx={X(r.year)} cy={Y(r.value)} r="4.5" fill="#1A1C42" stroke="#fff" strokeWidth="1.5" />
        ))}
      </svg>
      <div className="sbti-legend">
        <span><span className="sbti-legend__sw" style={{ background: "#003872" }} />Trayectoria lineal del objetivo</span>
        <span><span className="sbti-legend__sw" style={{ background: "#1A1C42" }} />Emisiones reales (Paso 7)</span>
      </div>
    </>
  );
}
